import { Link } from "react-router-dom";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer className="mt-24 bg-[#0F172A] text-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-serif text-3xl text-white">Albion Pantry</p>
          <p className="mt-3 text-sm text-slate-400 max-w-md leading-relaxed">
            Luxury chocolate, Christmas biscuits and pantry favourites, hand-picked from Marks & Spencer, Waitrose,
            Tesco and Sainsbury's and posted to you anywhere in the UK with Evri.
          </p>
          <div className="mt-6 max-w-lg"><NewsletterSignup prefix="newsletter" /></div>
        </div>
        <div className="text-sm space-y-2">
          <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-3">Help</p>
          <Link to="/contact" className="block hover:text-white" data-testid="footer-contact">Contact us</Link>
          <Link to="/gift-cards" className="block hover:text-white" data-testid="footer-giftcards">Gift cards</Link>
          <Link to="/delivery" className="block hover:text-white" data-testid="footer-delivery">Delivery & stock policy</Link>
          <Link to="/track" className="block hover:text-white" data-testid="footer-track">Track your order</Link>
        </div>
        <div className="text-sm space-y-2">
          <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-3">Shop owner</p>
          <Link to="/admin" className="block hover:text-white" data-testid="footer-admin">Admin login</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Albion Pantry. Albion Pantry is an independent reseller and is not affiliated with the stores named.
      </div>
    </footer>
  );
}
